import { ErrorMessages } from "fe-shared/src/types/common";
import Joi, { getAttachmentsSchema } from "fe-shared/src/helpers/validation";
import { COMMENT_LENGTH_LIMIT } from "../../../consts";
import { RetreadingTransactionFormContent } from "../../../types";

export const errorMessages: ErrorMessages = {
  companyId: {
    "any.required": "validation.companyRequired",
    "number.base": "validation.companyRequired",
  },
  attachments: {
    "array.min": "validation.documentsRequired",
  },
  comment: {
    "string.empty": "validation.commentRequired",
  },
  periodMonth: {
    "string.empty": "validation.periodRequired",
  },
};

export const initialContent: RetreadingTransactionFormContent = {
  attachments: [],
  comment: "",
  companyId: null,
  companyName: null,
  isKnownRetreaderTiresActualWeight: false,
  productionReportDate: null,
  periodYear: new Date().getFullYear(),
  periodMonth: new Date().toLocaleString("en-CA", { month: "long" }),
  collectionInfoMaterials: {},
  retreadRepairInfoMaterials: {},
  recoveryInfoMaterials: {
    RubberBuffing: 0,
  },
};

export const getValidationConfig = () => {
  const materialsSchema = Joi.object()
    .min(1)
    .pattern(Joi.string().min(2), Joi.number().integer().min(1).required());

  return Joi.object({
    attachments: getAttachmentsSchema("attachments").min(1),
    comment: Joi.string().max(COMMENT_LENGTH_LIMIT).allow("", null),
    productionReportDate: Joi.date().allow(null),
    companyId: Joi.number().integer().min(0).required(),
    companyName: Joi.string().max(300),
    isKnownRetreaderTiresActualWeight: Joi.boolean(),
    periodYear: Joi.number().integer().min(0).required(),
    periodMonth: Joi.string().required(),
    collectionInfoMaterials: materialsSchema,
    retreadRepairInfoMaterials: materialsSchema,
    recoveryInfoMaterials: Joi.object()
      .min(1)
      .pattern(Joi.string().min(2), Joi.number().integer().min(0).required()),
  });
};
